var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel-body" },
    [
      _vm.checkAffiliate
        ? _c("not-affiliate")
        : _c("div", [
            _c("div", [
              _c("fieldset", { staticClass: "border" }, [
                _vm.reward
                  ? _c("legend", { staticClass: "border" }, [
                      _c("b", [_vm._v(_vm._s(_vm.reward.title))])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "text-left" }, [
                  _vm.reward
                    ? _c("div", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.replaceHTMLSellerInfo(_vm.reward.content)
                          )
                        }
                      })
                    : _vm._e()
                ])
              ])
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("div", [
              _c("fieldset", { staticClass: "border" }, [
                _c("legend", { staticClass: "border" }, [
                  _c("b", [_vm._v("紹介者URL")])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text-left" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-info",
                      attrs: { type: "button" },
                      on: { click: _vm.copyText }
                    },
                    [_vm._v("コピー")]
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.getUrl,
                        expression: "getUrl"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { id: "affiliate_url", type: "text", readonly: "" },
                    domProps: { value: _vm.getUrl },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.getUrl = $event.target.value
                      }
                    }
                  })
                ])
              ])
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("div", [
              _c("fieldset", { staticClass: "border" }, [
                _vm.rewardSample
                  ? _c("legend", { staticClass: "border" }, [
                      _c("b", [_vm._v(_vm._s(_vm.rewardSample.title))])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "text-left" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-info",
                      attrs: { type: "button" },
                      on: { click: _vm.copyTextArea }
                    },
                    [_vm._v("コピー")]
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm.rewardSample
                    ? _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.rewardSample.content,
                            expression: "rewardSample.content"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          id: "affiliate_sample",
                          cols: "40",
                          rows: "10",
                          maxlength: "500"
                        },
                        domProps: { value: _vm.rewardSample.content },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.rewardSample,
                              "content",
                              $event.target.value
                            )
                          }
                        }
                      })
                    : _vm._e()
                ])
              ])
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("div", [
              _c("fieldset", { staticClass: "border" }, [
                _c("legend", { staticClass: "border" }, [
                  _c("b", [_vm._v("成果条件")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text-left" },
                  _vm._l(_vm.rewordCondition, function(item, index) {
                    return _c("dl", { key: index, staticClass: "row" }, [
                      _c("dt", { staticClass: "col-sm-3 text-truncate" }, [
                        _vm._v(_vm._s(item.title))
                      ]),
                      _c("dd", [_vm._v(_vm._s(item.content))])
                    ])
                  }),
                  0
                )
              ])
            ])
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6bb2a6a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bb2a6a2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/affiliate/Top.vue
// module id = null
// module chunks = 